<template>
  <div class="graphic-symbol-content" id="identidade-visual-grafismos-grafismo-inspirado-no-simbolo-globo" data-search-anchor>
    <div class="graphic-symbol-title-wrapper">
      <h1 class="graphic-symbol-title-span">{{ graphicSymbolTitleSpan }}</h1>
      <h1 class="graphic-symbol-title">{{ graphicSymbolTitle }}</h1>
    </div>
    <div class="description-graphic-symbol-title-icons-wrapper">
      <p class="graphic-symbol-description">{{ graphicSymbolDescription1 }}</p>
      <div class="graphic-symbol-icon-wrapper-first">
        <IconCheck />
        <p class="graphic-symbol-description1">{{ graphicSymbolDescription2 }}</p>
      </div>
      <div class="graphic-symbol-icon-wrapper-sec">
        <p class="graphic-symbol-description" style="margin: 0;">{{ graphicSymbolDescription3 }}</p>
      </div>
      <div class="graphic-Symbol-icon-wrapper">
        <div class="graphic-symbol-description-fica-a-dica">
          <p class="fica-a-dica">{{ graphicSymbolDescription4 }}</p>
          <p class="graphic-symbol-description5">{{ graphicSymbolDescription5 }}</p>
        </div>
      </div>
    </div>
    <div class="graphic-symbol-card-item" :style="{ backgroundImage: `url(${ImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import GraphicPageMixin from '@/mixins/graphic-page-mixin'
import { GraphicPageStore } from '@/store/visual-identity-page/graphic-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class GraphicsSymbolSection extends Mixins(GraphicPageMixin) {
  graphicPageStore: PageStoreContract = getModule(GraphicPageStore, this.$store)

  get graphicSymbolTitleSpan(): string {
    return this.getElementTitle(2, 0)
  }

  get graphicSymbolTitle(): string {
    return this.getElementText(2, 0)
  }

  get graphicSymbolDescription1(): string {
    return this.getElementText(2, 1)
  }

  get graphicSymbolDescription2(): string {
    return this.getElementText(2, 2)
  }

  get graphicSymbolDescription3(): string {
    return this.getElementText(2, 3)
  }

  get graphicSymbolDescription4(): string {
    return this.getElementText(2, 4)
  }

  get graphicSymbolDescription5(): string {
    return this.getElementText(2, 5)
  }

  get ImageSrc(): string {
    return this.getElementMedia(2, 6)
  }

  async getGraphicPage(): Promise<void> {
    await this.graphicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.graphicPageStore.isLoading) {
      await this.getGraphicPage()
    }
  }
}
</script>

<style lang="scss">
.graphic-symbol-content {
  display: grid;  
  max-width: 1032px;
  width: 100%;
}

.graphic-symbol-title-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-bottom: 1rem;  
}

.graphic-symbol-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-right: 5px;
  color: #b3b3b3;
}

.graphic-symbol-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000;
}

.description-graphic-symbol-title-icons-wrapper {
  position: relative;
  align-items: flex-start;  
  display: grid;
  grid-template-columns: 51.2% 48.8%;   
}

.graphic-symbol-description1 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  padding-left: 7px;  
  width: 378px;
  text-align: left;  
}

.graphic-symbol-description,
.fica-a-dica,
.graphic-symbol-description5 {
  font-size: 16px;  
  line-height: 20px;
  
  width: 430px;

  text-align: left;  
}

.graphic-symbol-description,
.graphic-symbol-description5 {
  font-weight: 600;
}

.graphic-symbol-icon-wrapper-first {
  display: flex;
  align-items: center;
}

.graphic-symbol-icon-wrapper-sec {
  display: flex;
  align-items: center;  
}

.graphic-symbol-icon-wrapper {
  display: flex;
  align-items: center;
}

.graphic-symbol-card-item {
  position: relative; 
  max-width: 1032px;   
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.graphic-symbol-description-fica-a-dica {
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  text-align: left;
  margin: 0;  
  width: 430px;
}
</style>
